<template>
  <BasicModal
    :title="'タスク編集'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container disp-scroll">
      <div class="input-field">
        <p>タイトル</p>
        <input class="input" v-model="editTask.title"/>
      </div>
      <div class="input-field">
        <p>説明</p>
        <input class="input" v-model="editTask.description"/>
      </div>
      <div class="input-field">
        <p>1日当たりの作業時間</p>
        <b-numberinput :editable="false" v-model="editTask.time_min" step="15" min="0" max="480" controls-position="compact"></b-numberinput>
        <p><span class="mdi mdi-timer -right-4px"></span>{{ getTaskTime(editTask.time_min) }}</p>
      </div>
      <div class="input-field">
        <p>お気に入り</p>
        <b-radio v-model="editTask.is_bookmark"
          :native-value="true">
          登録する
        </b-radio>
        <b-radio v-model="editTask.is_bookmark"
          :native-value="false">
          登録しない
        </b-radio>
      </div>
      <div class="input-field">
        <p>添付ファイル</p>
        <b-upload v-model="files" drag-drop multiple>
          <section class="upload-section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large"></b-icon>
              </p>
              <p>ファイルをアップロードしてください</p>
            </div>
          </section>
        </b-upload>
        <div style="margin-top: 4px;">
          <p><b>ファイル名</b></p>
          <template v-if="editTask.user_task_file.length > 0">
            <template v-for="(f, idx) in editTask.user_task_file">
              <a :key="idx + '-normal'" :href="f.attached_file" style="cursor: pointer;" target="_blank" rel="noopener"  v-if="!isFileChanging">
                {{f.filename}}
                <span @click="deleteFile(f.pk)" style="cursor: pointer;" class="mdi mdi-close -left-8px"></span>
              </a>
              <p :key="idx + '-normal'" v-else>
                <span class="mdi mdi-loading mdi-spin"></span>
              </p>
            </template>
          </template>
          <template v-if="files.length ===  0 && editTask.user_task_file.length === 0">
            未アップロードです。
          </template>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="updateUserTask(editTask)">変更する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import { getMin2Hour } from '@/functions/common/taskFunc'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    editTask: {
      type: Object,
      required: true
    },
    isFileChanging: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      files: [],
    }
  },
  created () {
    // 初期化
    this.files = []
  },
  watch: {
    files () {
      if (this.files.length > 0) {
        this.createUserTaskFile()
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', {
        flg: false,
        task: null
      })
    },
    getTaskTime (min) {
      return getMin2Hour(min)
    },
    updateUserTask (data) {
      this.$emit('updateUserTask', data)
      this.cancel()
    },
    createUserTaskFile () {
      this.$emit('createUserTaskFile', {
        files: this.files,
        pk: this.editTask.pk,
        idx: this.newFileLen
      })
      this.files = []
    },
    deleteFile (pk) {
      this.$emit('deleteUserTaskFile', pk)
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 8px;
  height: 500px;
}
.input-field {
  padding: 8px;
  text-align: left;
  p {
    font-weight: 600;
    margin-bottom: 2px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalEditTask.vue